var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiredX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    fill: "#F7F7F8",
    stroke: "#D2D5DF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7117 26.5514L41.6733 43.8336M41.6733 26.5514L28.7117 43.8336M35.1925 54.635C40.349 54.635 45.2942 52.5866 48.9404 48.9404C52.5866 45.2942 54.635 40.349 54.635 35.1925C54.635 30.036 52.5866 25.0908 48.9404 21.4446C45.2942 17.7984 40.349 15.75 35.1925 15.75C30.036 15.75 25.0908 17.7984 21.4446 21.4446C17.7984 25.0908 15.75 30.036 15.75 35.1925C15.75 40.349 17.7984 45.2942 21.4446 48.9404C25.0908 52.5866 30.036 54.635 35.1925 54.635Z",
    stroke: "#0F205E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiredX);
export default __webpack_public_path__ + "static/media/tired_x.7e34307a00a6a5f6cc78262cc632bf7e.svg";
export { ForwardRef as ReactComponent };